import { UserService } from '../../core/services/user.service';
import useService from '../../injector/hooks/useService';
import useTeamSettings from '../../containers/team/hooks/useTeamSettingsService';

export default function useUserService() {
  const userService = useService(UserService);
  const { isRBACEnabled } = useTeamSettings();

  return {
    user: userService.getUser(),
    isCurrentUserOwner: userService.getUser()?.isOwner,
    rbacPermissions: userService.getPermissions(),
    rbacRoles: userService.getUserRbacRoles(),
    updateRbacPermissions: permissions => {
      userService.setUserPermissions(permissions);
    },
    isInternalUser: () => userService.getUser()?.isHidden,
    isCurrentUserOwnerWithRbac: isRBACEnabled ? true : userService.getUser()?.isOwner
  };
}
